    export const GRID_TEMP = {
        l: '10',
        m: '5',
    }
  
    export const MARK_WIDTH = {
        desktop: {
        l: '137',
        ml: '70',
        m: '43.8',
        s: '40',
        xs: '38',
        },
        tablet: {
        l: '90.8',
        m: '43.8',
        s: '39.4',
        xs: '39.4',
        },
        mob: {
        l: '78.4',
        m: '34.8',
        s: '34.8',
        xs: '34.8',
        }
    }
  
    export const MARK_HEIGHT = {
        desktop: {
        l: '50',
        m: '32',
        s: '30',
        xs: '28',
        },
        tablet: {
        l: '30',
        m: '30',
        s: '30',
        xs: '24',
        },
        mob: {
        l: '30',
        m: '30',
        s: '30',
        xs: '30',
        }
    }    export const GRID_TEMP = {
        l: '10',
        m: '5',
    }
  
    export const MARK_WIDTH = {
        desktop: {
        l: '137',
        ml: '70',
        m: '43.8',
        s: '40',
        xs: '38',
        },
        tablet: {
        l: '90.8',
        m: '43.8',
        s: '39.4',
        xs: '39.4',
        },
        mob: {
        l: '78.4',
        m: '34.8',
        s: '34.8',
        xs: '34.8',
        }
    }
  
    export const MARK_HEIGHT = {
        desktop: {
        l: '50',
        m: '32',
        s: '30',
        xs: '28',
        },
        tablet: {
        l: '30',
        m: '30',
        s: '30',
        xs: '24',
        },
        mob: {
        l: '30',
        m: '30',
        s: '30',
        xs: '30',
        }
    }